$(document).ready(function(){
  var title = $('#title').val();
  var array_bundle = [];
  var array_idna = [];
  $('.content-bundle').hide();
  $('#content-1').show();
  $(".bundlingnya").hide();
  $(".bundlingnya2").hide();

  var id_pr_bd = $('#bundle1').val();
  var img_aktif = $('#produk-bundling-' + id_pr_bd);
  var variant_aktif = $('#variant-bundling-' + id_pr_bd);

  var id_pr_bd2 = $('#bundle2').val();
  var img_aktif2 = $('#produk-bundling2-' + id_pr_bd2);
  var variant_aktif2 = $('#variant-bundling2-' + id_pr_bd2);

  img_aktif.show();
  variant_aktif.show();

  console.log(title);
  img_aktif2.show();
  variant_aktif2.show();

  var produk1 = '/products/' + id_pr_bd + '.js';
  var produk2 = '/products/' + id_pr_bd2 + '.js';

  $('#bundle1').change(function() {
    img_aktif = $('#produk-bundling-' + $(this).val());
    variant_aktif = $('#variant-bundling-' + $(this).val());
    $(".bundlingnya").hide();
    img_aktif.show();
    variant_aktif.show();
    produk1 = '/products/' + $(this).val() + '.js';
  });

  $('#bundle2').change(function() {
    img_aktif2 = $('#produk-bundling2-' + $(this).val());
    variant_aktif2 = $('#variant-bundling2-' + $(this).val());
    $(".bundlingnya2").hide();
    img_aktif2.show();
    variant_aktif2.show();
    produk2 = '/products/' + $(this).val() + '.js';
  });

  $('#next_1').click(function() {
    var produk_ = $('#bundle1').val();
    var variant_id = $("#variant-" + produk_).val();
    $('#tab-1').removeClass('active');
    $('#tab-2').addClass('active');
    $('#content-1').hide();
    $('#content-2').show();
    array_bundle.push({
      id: variant_id,
      quantity: 1,
      properties: {
        'bundling name': title
      }
    });

    console.log(array_bundle);
  });

  $('#back_next_1').click(function() {
    var produk_ = $('#bundle1').val();
    var variant_id = $("#variant-" + produk_).val();
    $('#tab-1').addClass('active');
    $('#tab-2').removeClass('active');
    $('#content-1').show();
    $('#content-2').hide();
    array_bundle.pop();
  });


  $('#next_2').click(function() {

    var produk_2 = $('#bundle2').val();
    var variant_id2 = $("#variant2-" + produk_2).val();
    $('#tab-2').removeClass('active');
    $('#tab-3').addClass('active');

    array_bundle.push({
      id: variant_id2,
      quantity: 1,
      properties: {
        'bundling name': title
      }
    });
    $('#content-2').hide();
    $('#content-3').show();

    jQuery.getJSON(produk1, function(product1) {
      var sizena = [];
      for (var i = 0; i < product1.variants.length; i++) {
        if (product1.variants[i].id == array_bundle[0].id) {
          sizena = product1.variants[i].title
        }
      }
      console.log(sizena);
      $('#product1').html('<img src="' + product1.featured_image + ' class="lazyload" /> <p>' + product1.title + '</p>');
      array_idna.push({
        id: product1.id
      });
    });

    jQuery.getJSON(produk2, function(product2) {
      var sizena = [];
      for (var i = 0; i < product2.variants.length; i++) {
        if (product2.variants[i].id == array_bundle[1].id) {
          sizena = product2.variants[i].title
        }
      }

      $('#product2').html('<img src="' + product2.featured_image + ' class="lazyload" /> <p>' + product2.title + '</p>');
      array_idna.push({
        id: product2.id
      });
    });

    console.log(array_bundle);
  });

  $('#back_next_2').click(function() {
    var produk_2 = $('#bundle2').val();
    var variant_id2 = $("#variant2-" + produk_2).val();
    $('#tab-2').addClass('active');
    $('#tab-3').removeClass('active');
    $('#content-2').show();
    $('#content-3').hide();
    array_bundle.pop();
  });

  $('#bundling').click(function() {
    var cart = jQuery.post('/cart/add.js', {
      items: array_bundle
    });
    setTimeout(function() {
      window.location = '/cart';
    }, 2000);

  });
})